import { Alert, Box, Grid, Table, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Helper from '../../../../../utils/helper';
import { useSelector } from 'react-redux';
import { UOSP } from '../userOrderProductDetails.classes';

const tableCellWrapperSx = {
    display: 'flex',
    minWidth: '130px',
    textAlign: 'right',
};

const tableCellHeaderSx = {
    fontWeight: 'bold',
    textAlign: 'right',
    minWidth: '200px',
    float: 'right',
};

function UserOrderShippingPriceInfos({ shipment }: any) {
    const { t } = useTranslation();
    const darkMode: any = useSelector((state: any) => state?.darkMode);
    const grayBackgroundSx = {
        backgroundColor: darkMode?.isDarkMode ? '#111' : '#ECECEC',
        width: '120px',
        textAlign: 'right',
        padding: '2rem',
    };
    const priceData = shipment?.shippingListPriceModels;
    const discountList = shipment?.shippingListDiscountList;
    const getDiscountList = (discountList: any) => {
        if (discountList && discountList.length > 0) {
            return discountList.map((item: any, index: any) => (
                <div
                    key={index}
                    className={UOSP.discountWrap}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignContent: 'center',
                        marginLeft: '1rem',
                    }}
                >
                    <Alert className={UOSP.discountAlert} severity="warning" icon>
                        <div style={{ display: 'flex', gap: '1rem' }}>
                            <p style={{ fontSize: '12px', fontWeight: 'bold' }}>({item.discountSourceId}) : </p>
                            <p style={{ fontSize: '12px', color: 'red' }}>{item.discountDescription}</p>
                            <p style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                {Helper.formatCurrencyByCountry(
                                    item.discountFloat,
                                    JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.countryCode
                                )}{' '}
                                {item.currency}
                            </p>
                        </div>
                    </Alert>
                </div>
            ));
        }
    };

    return (
        <>
            <Grid className={UOSP.root} container direction="row">
                <Grid
                    size={{
                        lg: 8,
                        md: 5,
                        xs: 4,
                    }}
                >
                    {getDiscountList(discountList)}
                </Grid>
                <Grid
                    size={{
                        lg: 3,
                        md: 3,
                        xs: 3,
                    }}
                >
                    {priceData && (
                        <div className={UOSP.tableWrap} style={{ padding: '2rem' }}>
                            <Table className={UOSP.table}>
                                <TableHead>
                                    <TableRow
                                        className={UOSP.tableHeadRow}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            float: 'right',
                                        }}
                                    >
                                        <Box sx={tableCellWrapperSx}>
                                            <TableCell className={UOSP.cellLabel} sx={tableCellHeaderSx}>{t('orderDetail.price')}</TableCell>
                                            <TableCell sx={grayBackgroundSx}>{priceData.price}</TableCell>
                                        </Box>
                                        <Box sx={tableCellWrapperSx}>
                                            <TableCell className={UOSP.cellLabel} sx={tableCellHeaderSx}>{t('orderDetail.discount')}</TableCell>
                                            <TableCell sx={grayBackgroundSx}>{priceData.discount}</TableCell>
                                        </Box>
                                        <Box sx={tableCellWrapperSx}>
                                            <TableCell className={UOSP.cellLabel} sx={tableCellHeaderSx}>{t('orderDetail.subPrice')}</TableCell>
                                            <TableCell sx={grayBackgroundSx}>{priceData.subPrice}</TableCell>
                                        </Box>
                                        <Box sx={tableCellWrapperSx}>
                                            <TableCell className={UOSP.cellLabel} sx={tableCellHeaderSx}>
                                                {t('cargoFeeManagement.cargoFee')}
                                            </TableCell>
                                            <TableCell sx={grayBackgroundSx}>{priceData.shippingPrice}</TableCell>
                                        </Box>
                                        <Box sx={tableCellWrapperSx}>
                                            <TableCell className={UOSP.cellLabel} sx={tableCellHeaderSx}>
                                                {t('orderDetail.additionalPrice')}
                                            </TableCell>
                                            <TableCell sx={grayBackgroundSx}>{priceData.additionalPrice}</TableCell>
                                        </Box>
                                        <Box sx={tableCellWrapperSx}>
                                            <TableCell className={UOSP.cellLabel} sx={tableCellHeaderSx}>{t('orderDetail.totalPrice')}</TableCell>
                                            <TableCell sx={grayBackgroundSx}>{priceData.totalPrice}</TableCell>
                                        </Box>
                                    </TableRow>
                                </TableHead>
                            </Table>
                        </div>
                    )}
                </Grid>
            </Grid>
        </>
    );
}

export default UserOrderShippingPriceInfos;
